import {
  BookkeepingTagDbValue,
  BookkeepingTagNavItemValue,
  convertBookkeepingTagDbValueToNavItemValue,
} from '@components'

import { AttachmentParsedDataTagScore } from '../../../../../types/attachmentParsedDataTagScore'

export const getBookkeepingTagsFromTagScores = async (
  tagScores: AttachmentParsedDataTagScore[],
  locale: string,
  organizationId?: string,
): Promise<BookkeepingTagNavItemValue[]> => {
  const bookkeepingTags: BookkeepingTagNavItemValue[] = []

  for (const tagScore of tagScores) {
    const value: BookkeepingTagDbValue = {
      tagId: tagScore.tagId,
      name: tagScore.tagName,
    }
    const bookkeepingTag = await convertBookkeepingTagDbValueToNavItemValue({
      dbValue: value,
      locale,
      organizationId,
    })

    if (bookkeepingTag) {
      bookkeepingTags.push(bookkeepingTag)
    }
  }

  return bookkeepingTags
}
